/*

FILE: utils.js
DESCRIPTION: Re-usable functions with no side-effects
AUTHOR(S): R.J. LaCount

*/

const debounce = (func, time) => {
	let timer;
	return (event) => {
		if (timer) clearTimeout(timer);
		timer = setTimeout(func, time || 300, event);
	};
}

const getUrlParameter = (name) => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	const results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const strPadLeft = (string, pad, length) => {
	return (new Array(length + 1).join(pad) + string).slice(-length);
}

const renderTimestamp = (duration) => {
	const minutes = Math.floor(duration / 60);
	const seconds = duration - minutes * 60;
	return strPadLeft(minutes, '0', 2) + ':' + strPadLeft(seconds, '0', 2);
}

export { debounce, getUrlParameter, renderTimestamp };
